import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe, getCurrencySymbol} from '@angular/common';
import {Store} from '@ngxs/store';
import Organization from '../models/organization/organization.model';
import {OrganizationState} from '../state/organization.state';

@Pipe({
  standalone: false,
  name: 'currency'
})
export class AsyncCurrencyPipe extends CurrencyPipe implements PipeTransform {
  private readonly organization: Organization;

  constructor(private store: Store, @Inject(LOCALE_ID) public locale: string) {
    super(locale);
    this.organization = this.store.selectSnapshot(OrganizationState.organization);
  }

  getCurrencyCode(): string | undefined {
    if (this.organization) {
      return this.organization.currency;
    }
    return undefined;
  }

  // @ts-ignore
  transform(
    value: any,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string, locale?: string): string | null {
    return super.transform(value, this.getCurrencyCode(), 'symbol-narrow', digitsInfo, locale);
  }

}
